import { render, staticRenderFns } from "./hostMappingModuleDetail.vue?vue&type=template&id=06735b64&scoped=true&"
import script from "./hostMappingModuleDetail.vue?vue&type=script&lang=js&"
export * from "./hostMappingModuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./hostMappingModuleDetail.vue?vue&type=style&index=0&id=06735b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06735b64",
  null
  
)

export default component.exports